module.exports = __webpack_public_path__ + "media/images/athletes/2095-4fdae74efac14888d5fd4d289a09a784.png";